var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Search results for Logout - Flaticon-3",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9337",
  d: "M29.062 14.062h-11.87a.937.937 0 1 1 0-1.874h11.87a.937.937 0 1 1 0 1.874Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9338",
  d: "M24.377 18.747a.938.938 0 0 1-.662-1.6l4.023-4.023-4.023-4.023a.938.938 0 1 1 1.326-1.326l4.685 4.685a.937.937 0 0 1 0 1.326l-4.685 4.685a.931.931 0 0 1-.664.276Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9339",
  d: "M10 30a2.574 2.574 0 0 1-.775-.116L1.7 27.377A2.523 2.523 0 0 1 0 25V2.5A2.5 2.5 0 0 1 2.5 0a2.576 2.576 0 0 1 .775.116l7.519 2.506a2.523 2.523 0 0 1 1.7 2.377v22.5a2.5 2.5 0 0 1-2.5 2.5ZM2.5 1.875a.627.627 0 0 0-.625.625V25a.65.65 0 0 0 .434.6l7.484 2.5a.678.678 0 0 0 .2.027.627.627 0 0 0 .625-.625V5a.65.65 0 0 0-.434-.6L2.7 1.902a.678.678 0 0 0-.2-.027Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9340",
  d: "M19.054 9.992a.937.937 0 0 1-.937-.937V3.436a1.564 1.564 0 0 0-1.562-1.562H2.494a.937.937 0 1 1 0-1.874h14.061a3.439 3.439 0 0 1 3.439 3.436v5.623a.937.937 0 0 1-.94.933Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9341",
  d: "M16.561 26.252h-5a.937.937 0 1 1 0-1.874h5a1.564 1.564 0 0 0 1.562-1.562v-5.622a.937.937 0 0 1 1.874 0v5.622a3.439 3.439 0 0 1-3.436 3.436Zm0 0"
}))));
export default SvgLogout;